// extracted by mini-css-extract-plugin
module.exports = {"actionSection":"Attribute-tab_actionSection_2OcOw","searchContainer":"Attribute-tab_searchContainer_3YzeD","filterInput":"Attribute-tab_filterInput_f1V8v"};